import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type ReactNode, useState } from 'react';
import { useToast } from '../../components/ui/toast';
import { ApiError } from '../api/client';

interface Props {
  children: ReactNode;
}

export function QueryProvider({ children }: Props): JSX.Element {
  const { showToast } = useToast();
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: (count, err) => {
              if (err instanceof ApiError && err.status >= 400 && err.status < 500) return false;
              return count < 2;
            },
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: false,
          },
        },
        queryCache: new QueryCache({
          onError: (err) => {
            if (err instanceof ApiError && err.status === 401) return; // store will boot user
            const message = err instanceof Error ? err.message : 'request failed';
            showToast({ title: 'Could not load data', description: message, variant: 'danger' });
          },
        }),
      }),
  );
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
